import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class OrganisationRoute extends Route {
  @service organisation;

  model() {
    return this.organisation.organisation;
  }
}

export default instrumentRoutePerformance(OrganisationRoute);
